import { Subscription } from 'rxjs';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { UserService } from 'src/app/view/users/services/user.service';
import { ContextType, SwitchContextData } from '../../services/models/context.data';
import { ContextDataService } from '../../services/context.data-service';
import { ContextService } from '../../services/context.service';
import { BrowserNtfPanelComponent } from '../browser-ntf-panel/browser-ntf-panel.component';

@Component({
  selector: 'app-mobile-other-actions',
  templateUrl: './mobile-other-actions.component.html',
  styleUrls: ['./mobile-other-actions.component.scss']
})
export class MobileOtherActionsComponent implements OnInit, OnDestroy {
  public readonly CT = ContextType;
  public estateForm: FormControl = new FormControl(this.ctxDS.peekCurrentEstateId());

  private subscription$: Subscription = new Subscription();
  private selectionChangeId = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SwitchContextData,
    public dialogRef: MatDialogRef<MobileOtherActionsComponent>,
    public ls: LocalizationService,
    private dialogService: DialogService,
    private userService: UserService,
    private ctxDS: ContextDataService,
    private ctxSrv: ContextService,
    private router: Router
  ) {}

  ngOnInit() {
    this.subscription$.add(
      this.ctxDS.currentEstate$.subscribe((estate) => this.estateForm.patchValue(estate?.id, { emitEvent: false }))
    );
    this.subscription$.add(
      this.ctxDS.context$.subscribe((contextType) => {
        if (contextType) this.data = { ...this.data, contextType };
      })
    );
    this.subscription$.add(
      this.estateForm.valueChanges.subscribe(async (estateId) => {
        if (!this.data.estates.some((estate) => estate.id === estateId)) return;
        if (estateId === this.ctxDS.peekCurrentEstateId()) return;
        const changeId = ++this.selectionChangeId;
        this.ctxSrv.setContext(ContextType.ESTATE);
        await this.ctxSrv.setEstate(estateId);
        if (changeId !== this.selectionChangeId || this.data.contextType !== ContextType.ESTATE) return;
        this.router.navigate(['/dashboard']);
        this.dialogRef.close();
      })
    );
  }

  ngOnDestroy(): void {
    ++this.selectionChangeId;
    this.subscription$.unsubscribe();
  }

  close() {
    this.dialogRef.close();
  }

  public setLanguage(lan: string): void {
    this.ls.currentLang = lan;
    const uid = this.ctxDS.peekCurrentUserId();
    if (uid) this.userService.setUserLanguage(uid, lan);
  }

  public showBrowserNotifications(): void {
    this.dialogRef.close();
    this.dialogService.openPanelDialog(
      BrowserNtfPanelComponent,
      { estates: this.data.estates },
      {
        width: '100%',
        maxWidth: '100%',
        minWidth: '0',
        height: '100vh',
        maxHeight: '100vh',
        panelClass: ['unpadded-dialog', 'browser-ntf-panel-dialog'],
        autoFocus: false
      }
    );
  }
}
